import { render, staticRenderFns } from "./app-project.vue?vue&type=template&id=a37bc088&scoped=true&"
import script from "./app-project.vue?vue&type=script&lang=js&"
export * from "./app-project.vue?vue&type=script&lang=js&"
import style0 from "./app-project.vue?vue&type=style&index=0&id=a37bc088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37bc088",
  null
  
)

export default component.exports